import React, { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import '../../css/style.css'
import '../../css/SignUp.css'
import '../../css/VerifyPhone.css'
import axios from 'axios'

export default function VerifyPhone() {
  const navigate = useNavigate()
  const location = useLocation()
  const phone = location.state?.phone || ''
  // const OTP = location.state?.OTP || ''
  // const OTPExpiresAt = location.state?.OTPExpiresAt || ''
  // const MobilePhone= location.state?.MobilePhone || ''
  const id= location.state?.id || ''
  
  const [code, setCode] = useState(['', '', '', '', ''])
  const [timer, setTimer] = useState(59)
  const [canResend, setCanResend] = useState(false)
  const [isVerifying, setIsVerifying] = useState(false)
  const [hasErr, setHasErr] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const [success, setSuccess] = useState(false)
  const inputRefs = useRef([])

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus()
    }
  }, [])

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(prev => prev - 1)
      }, 1000)
      return () => clearInterval(interval)
    } else {
      setCanResend(true)
    }
  }, [timer])

  const formatTimer = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0')
    const s = (seconds % 60).toString().padStart(2, '0')
    return `${m}:${s}`
  }

  const formatPhone = (phoneStr) => {
    if (!phoneStr) return '+XX XXXX XXXX'
    // Add + if not present, add spaces for readability
    let p = phoneStr.startsWith('+') ? phoneStr : '+' + phoneStr
    // Try to format nicely
    if (p.length > 5) {
      return p.slice(0, 3) + ' ' + p.slice(3, 5) + ' ' + p.slice(5, 9) + ' ' + p.slice(9)
    }
    return p
  }

  const handleChange = (index, value) => {
    // Only allow digits
    if (value && !/^\d$/.test(value)) return

    const newCode = [...code]
    newCode[index] = value
    setCode(newCode)

    // Auto-focus next input
    if (value && index < 4) {
      inputRefs.current[index + 1].focus()
    }
  }

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputRefs.current[index - 1].focus()
    }
  }

  const handlePaste = (e) => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 5)
    if (pastedData.length > 0) {
      const newCode = [...code]
      for (let i = 0; i < pastedData.length && i < 5; i++) {
        newCode[i] = pastedData[i]
      }
      setCode(newCode)
      // Focus last filled or next empty
      const focusIndex = Math.min(pastedData.length, 4)
      inputRefs.current[focusIndex].focus()
    }
  }

  const resendCode = () => {
    if (!canResend) return
    setTimer(59)
    setCanResend(false)
    setHasErr(false)
    // Call API to resend code
    // axios.post(process.env.REACT_APP_API_SERVER + 'resend-code', { phone })
    alert('Resend code functionality is not implemented yet.')
  }

  const verify = (e) => {
    e.preventDefault()
    const fullCode = code.join('')
    const obj={
      id:id,
      phone:phone,
      OTP:fullCode
    }
    if (fullCode.length < 5) {
      setHasErr(true)
      setErrMsg('Please enter the complete 5-digit code')
      return
    }

    setIsVerifying(true)
    setHasErr(false)

    axios.post(process.env.REACT_APP_API_SERVER + 'registerotp/verifyotp', obj).then(res => {
      if (res.data.err == 0) {
        setSuccess(true)
        setTimeout(() => {
          navigate('/welcome')
        }, 1500)
      } else {
        setHasErr(true)
        setErrMsg(res.data.msg || 'Verification failed, please try again')
      }
    }).catch(err => {
      setHasErr(true)
      setErrMsg('An error occurred during verification, please try again')
    }).finally(() => {
      setIsVerifying(false)
    })

    // // For now, navigate to login/activate since the backend verification 
    // // endpoint needs to be confirmed
    // // Replace this with actual API call when ready:
    // // axios.post(process.env.REACT_APP_API_SERVER + 'verify-phone', { phone, code: fullCode })
    // setTimeout(() => {
    //   setIsVerifying(false)
    //   navigate('/welcome')
    // }, 1500)
  }

  const changePhone = () => {
    axios.get(process.env.REACT_APP_API_SERVER + 'registerotp/changephone/'+id).then(res => {
      if (res.data.err == 0) {
        navigate('/signup')
      } else {
        alert('An error has occured, please try again')
      }
    }).catch(err => {
      alert('An error has occured, please try again')
    })

    //navigate('/signup')
  }

  const resendCode1 = () => {
    setCode(['', '', '', '', ''])
    if (inputRefs.current[0]) inputRefs.current[0].focus()
    axios.get(process.env.REACT_APP_API_SERVER + 'registerotp/sendotp/'+ id+'/'+phone).then(res => {
      if (res.data.err == 0) {
        alert('We have sent a 5-digit verification code to your phone number')
      } else {
        alert('An error has occured, please try again')
      }
    }).catch(err => {
      alert('An error has occured, please try again')
    })

    //navigate('/signup')
  }



  return (
    <div className="container container-mobile">
      <div className="verify-page">

        <div className="verify-header">
          <button className="verify-back-btn" onClick={() => navigate('/signup')}>
            <i className="bi bi-chevron-left"></i>
          </button>
          <h2>Verify your phone</h2>
        </div>

        <div className="verify-content">
          <div className="verify-icon">
            <i className="bi bi-chat-dots"></i>
          </div>

          <p className="verify-subtitle">
            We have sent a 5-digit verification code<br/>
            to your phone number
          </p>
          <p className="verify-phone">{formatPhone(phone)}</p>

          {hasErr &&
            <div className="alert alert-danger" role="alert">
              {errMsg}
            </div>
          }

          {success &&
            <div className="alert alert-success" role="alert">
              Phone verified successfully!
            </div>
          }

          <form onSubmit={verify}>
            <div className="code-inputs">
              {code.map((digit, index) => (
                <input
                  required
                  key={index}
                  ref={el => inputRefs.current[index] = el}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  className={`code-box ${digit ? 'filled' : ''}`}
                  value={digit}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={index === 0 ? handlePaste : undefined}
                />
              ))}
            </div>

            <p className="code-hint">Enter the 5-digit code sent to your phone</p>

            <div className="resend-section">
              <p>Didn't receive the code?</p>
              {canResend ? (
                <span className="resend-link" onClick={resendCode1}>Resend code</span>
              ) : (
                <p>Resend code in <strong>{formatTimer(timer)}</strong></p>
                // <p>Resend code in <strong>{formatTimer(timer)}</strong></p>
              )}
            </div>

            <button type="submit" className="login-btn-styled" disabled={isVerifying}>
              {isVerifying ? 'Verifying...' : 'Verify'}
              {!isVerifying && <span className="btn-arrow">→</span>}
            </button>
          </form>

          <div className="change-phone-link" onClick={() => changePhone()}>
            <i className="bi bi-chevron-left"></i> Change phone number
          </div>
        </div>

      </div>
    </div>
  )
}
